import React, { useState, useEffect } from 'react';
import { FormikSearchSelect } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';
import scus from 'state-counties-us';

const County = () => {
  const { values } = useFormikContext();
  const [captionText, setCaptionText] = useState();

  const countyByState = stateInitials => {
    if (stateInitials?.length > 0) {
      const countiesByState = scus.getCountiesByState(stateInitials) || [];
      const uniqueCounties = countiesByState.map(county => {
        return { key: county, value: county };
      });
      return uniqueCounties;
    }
    return null;
  };

  const isStateEmpty = !values.state || values.state === 'null';

  useEffect(() => {
    if (isStateEmpty) {
      setCaptionText('You must first select a state.');
    } else {
      setCaptionText(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.state]);

  return (
    <FormikSearchSelect
      label="County"
      errorMessage={captionText}
      name="county"
      disabled={isStateEmpty}
      items={countyByState(values?.state)}
      placeholder="Select County"
    />
  );
};
export default County;
